import { put, takeLatest } from 'redux-saga/effects';
import ClientAPI from './../../ClientAPI/ClientAPI';
import * as paths from './../../ClientAPI/paths';
import { forgotUsername } from '@/modules/casino/store/actions/actionTypes';
import { sendForgotUsernameEmailResponse } from '@/modules/casino/store/actions/forgot_username';

export function* forgotUsernameSendEmailSaga(action: any) {
  const axios = ClientAPI.getInstance();
  const email = action.email;
  try {
    // @ts-ignore
    const response: any = yield axios({
      url: paths.forgotUsername.SEND_EMAIL,
      method: 'post',
      data: {
        mail: email,
      },
    });

    if (!response) {
      yield put(sendForgotUsernameEmailResponse({ ResponseCode: 1 }));
      throw new Error('[ERROR] Send Email response is empty!');
    }

    if (typeof response['result'] === 'undefined') {
      yield put(sendForgotUsernameEmailResponse({ ResponseCode: 1 }));
      throw new Error("[ERROR] Send Email response has no 'result' property");
    }

    yield put(sendForgotUsernameEmailResponse(response.result));
  } catch (error) {
    console.log(error);
    return;
  }
}

export default function* watchForgotUsername() {

  yield takeLatest(forgotUsername.SEND_EMAIL, forgotUsernameSendEmailSaga);
}